import { render, staticRenderFns } from "./OrganizationStaffList.vue?vue&type=template&id=170c4680&"
import script from "./OrganizationStaffList.vue?vue&type=script&lang=js&"
export * from "./OrganizationStaffList.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationStaffList.vue?vue&type=style&index=0&id=170c4680&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports